import { AppLayout } from "@/components/layout/app-layout";
import { PageHeader } from "@/components/layout/page-header";
import { ExportWizard } from "@/components/export/export-wizard";
import { PreExportValidation } from "@/components/export/pre-export-validation";
import { ExportHistory } from "@/components/export/export-history";

const ExportCenter = () => {
  return <AppLayout>
      <PageHeader 
        title="Export to Accounting"
        showBackButton
      />
      <main className="flex-1 p-page-padding lg:p-page-padding-lg overflow-y-auto">
        <ExportWizard />
        
        <section className="grid grid-cols-1 lg:grid-cols-5 gap-section-gap mt-header-mb">
          <div className="lg:col-span-2">
            <PreExportValidation />
          </div>
          <div className="lg:col-span-3">
            <ExportHistory />
          </div>
        </section>
        
        <footer className="mt-8 pt-6 border-t border-brand-border flex justify-between items-center">
          <p className="text-xs text-brand-text-primary">Copyright © 2025 Swiss Finance OS</p>
          <div className="flex items-center gap-4 text-xs text-brand-text-secondary">
            <span className="hover:text-brand-primary cursor-pointer">Privacy Policy</span>
            <span className="hover:text-brand-primary cursor-pointer">Terms & Conditions</span>
            <span className="hover:text-brand-primary cursor-pointer">Contact</span>
          </div>
        </footer>
      </main>
    </AppLayout>;
};
export default ExportCenter;